import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { MEETING_TALKING_POINTS_FILTER_OPTIONS } from '../../../constants/meetingTalkingPointsFilter';

/**
 * MeetingTalkingPointsFilterSelector - A dropdown selector for filtering meetings by talking points
 *
 * @param {string} value - The selected filter value
 * @param {Function} onChange - Callback when selection changes (value) => void
 * @param {boolean} disabled - Whether the selector is disabled
 * @param {string} label - Label for the selector
 * @param {string} size - Size of the select ('small' | 'medium')
 * @param {number} minWidth - Minimum width in pixels
 * @param {Object} sx - Additional styles for the FormControl
 */
const MeetingTalkingPointsFilterSelector = ({
  value = '',
  onChange,
  disabled = false,
  label = 'Talking Points',
  size = 'small',
  minWidth = 180,
  sx = {},
}) => {
  return (
    <FormControl size={size} sx={{ minWidth, ...sx }} disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        label={label}
      >
        {MEETING_TALKING_POINTS_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MeetingTalkingPointsFilterSelector;
